module.exports = __webpack_public_path__ + "6bc95d4db95917284cd8079b0ccd69bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/icons/icons.ttf
// module id = 383
// module chunks = 0